import { render, staticRenderFns } from "./MiniProjectsTable.vue?vue&type=template&id=ffbecfa0&scoped=true"
import script from "./MiniProjectsTable.vue?vue&type=script&lang=js"
export * from "./MiniProjectsTable.vue?vue&type=script&lang=js"
import style0 from "./MiniProjectsTable.vue?vue&type=style&index=0&id=ffbecfa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbecfa0",
  null
  
)

export default component.exports